module.exports = __webpack_public_path__ + "static/media/img139.88e57ed6.jpg";